import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, ClipboardList } from 'lucide-react';
import { useContent } from '../lib/content.jsx';
import { Loading, Empty, ErrorNotice } from '../components/states.jsx';
import { Layout } from '../components/Layout.jsx';

export default function Archive() {
  const { years, status, error } = useContent();
  const current = years.find((y) => y.isCurrent);
  const archived = years.filter((y) => !y.isCurrent);

  return (
    <Layout year={current} basePath="">
      <div className="page-head">
        <h1>Archiv ročníků</h1>
        <p>Materiály z předchozích let zůstávají dostupné beze změny.</p>
      </div>

      {status === 'loading' && <Loading />}
      {status === 'error' && <ErrorNotice>{error}</ErrorNotice>}

      {status === 'ready' && (
        archived.length === 0 ? (
          <Empty title="Archiv je zatím prázdný">Až tenhle ročník skončí, přesune se sem.</Empty>
        ) : (
          <div className="card-grid">
            {archived.map((year) => (
              <Link key={year.slug} to={`/archiv/${year.slug}`} className="card card-link">
                <div className="section-title" style={{ marginBottom: '.5rem' }}>
                  <h2 style={{ fontSize: '1.15rem' }}>{year.label}</h2>
                  <ArrowRight size={16} style={{ marginLeft: 'auto', color: 'var(--accent)' }} aria-hidden="true" />
                </div>
                <div className="chip-row">
                  <span className="chip chip-quiet">
                    <BookOpen size={13} aria-hidden="true" /> {year.lectures.length} hodin
                  </span>
                  <span className="chip chip-quiet">
                    <ClipboardList size={13} aria-hidden="true" /> {year.assignments.length} úkolů
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )
      )}
    </Layout>
  );
}
